import { render, staticRenderFns } from "./IconSpinner.vue?vue&type=template&id=4e994d6d&scoped=true"
import script from "./IconSpinner.vue?vue&type=script&lang=js"
export * from "./IconSpinner.vue?vue&type=script&lang=js"
import style0 from "./IconSpinner.vue?vue&type=style&index=0&id=4e994d6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e994d6d",
  null
  
)

export default component.exports